import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import AuctionSection from "./components/AuctionSection";
import CourseSection from "./components/CourseSection";
import ReportSection from "./components/ReportSection";
import ConsultationCTA from "./components/ConsultationCTA";
import ReviewSection from "./components/ReviewSection";
import FeaturesSection from "./components/FeaturesSection";
import BlogSection from "./components/BlogSection";
import { motion } from "motion/react";

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_KR']">
      <Navbar />
      <main>
        <HeroSection />
        <AuctionSection />
        <CourseSection />
        <ReportSection />
        <ConsultationCTA />
        <ReviewSection />
        <FeaturesSection />
        <BlogSection />
        {/* Final CTA */}
        <motion.section
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] as const }}
          className="w-full py-16 md:py-20 px-4 md:px-6 bg-[#FAFAF8]"
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.6, ease: "easeOut" as const }}
            className="max-w-[700px] mx-auto text-center"
          >
            <h2 className="text-2xl md:text-3xl font-bold text-[#1C1917] mb-4">
              지금 바로 경매 공부, 시작해볼까요?
            </h2>
            <p className="text-sm text-[#8C8780] mb-8">
              무료 입문 강의로 부담 없이 시작하세요.
              <br />
              강스터디가 여러분의 첫 경매 투자를 함께합니다.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <motion.a
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.97 }}
                href="/lectures?category=beginner"
                className="w-full sm:w-auto px-8 py-3.5 bg-[#1C1917] text-white font-semibold rounded-full hover:bg-[#C4956A] transition-all text-sm whitespace-nowrap text-center inline-block"
              >
                <i className="ri-play-circle-line mr-2"></i>
                무료강의 보기
              </motion.a>
              <motion.a
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.97 }}
                href="/register"
                className="w-full sm:w-auto px-8 py-3.5 bg-[#C4956A] text-white font-semibold rounded-full hover:bg-[#B08050] transition-all text-sm whitespace-nowrap text-center inline-block"
              >
                <i className="ri-user-add-line mr-2"></i>
                회원가입하기
              </motion.a>
            </div>
          </motion.div>
        </motion.section>
      </main>
      <Footer />
    </div>
  );
}